import React from 'react';
import TextField from 'material-ui/TextField';
import { Row, Col } from 'react-flexbox-grid';
import FontIcon from 'material-ui/FontIcon';

class CustomerFilter extends React.Component {

    constructor(props) {
        super(props);
        this.state = {key: (this.props.searchKey?this.props.searchKey:'')};
    }

    setSearchKey(key){
        this.setState({key: key})
    }

    onKeyPress(event) {
        if (event.charCode === 13) { // enter key pressed
            event.preventDefault();
            this.props.fetchFilteredCustomers(this.state.key);
        }
    }

    render() {
        return (
            <Row middle="xs">
                <Col xs={12} sm={12} md={12} lg={12} style={{textAlign: 'right'}}>
                    <div style={{textAlign: 'right'}}>

                        <TextField name="input"
                                   value={this.state.key}
                                   onChange={(e, value)=>{this.setSearchKey(value)}}
                                   onKeyPress={(event)=>{this.onKeyPress(event)}}
                                   hintText="Find customers ...">
                        </TextField>
                        <FontIcon className="material-icons">search</FontIcon>
                    </div>
                </Col>
            </Row>
        )
    }
}

export default CustomerFilter;





// WEBPACK FOOTER //
// ./src/components/customerList/CustomerListFilter.js